<template>
  <AppTableUser :name="user ? user.full_name : ''" :photo="user && user.crop ? user.crop.crop_url : ''" />
</template>

<script>
import AppTableUser from '@/components/AppTableUser.vue'

export default {
  name: 'SupportTicketTablePerson',
  components: { AppTableUser },
  props: {
    user: { type: Object, default: null },
    compact: Boolean,
    emptyText: { type: String, default: 'Unassigned' }
  }
}
</script>
